/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
/* eslint-disable indent */

import React from 'react';
import { TableColumn } from 'react-data-table-component';

import { DefaultTable } from 'src/components';

import { IQleNewHireEnrollmentEvent } from 'src/interfaces';

import { formatDateConverter } from 'src/utils/formatDateConvert';

const customStyles = {
  headRow: {
    style: {
      border: 'none',
    },
  },
  headCells: {
    style: {
      color: '#9399B2',
      font: 'normal normal bold 15px Biotif',
    },
  },
  rows: {
    style: {
      font: 'normal normal normal 14px Biotif',
      color: '#1B1D35',
      borderRadius: '5px',
      '&:not(:last-of-type)': {
        borderBottomWidth: '0px',
      },
    },
    stripedStyle: {
      color: '#1B1D35',
      backgroundColor: '#F3F4F8',
    },
    highlightOnHoverStyle: {
      backgroundColor: 'rgb(230, 244, 244)',
      borderBottomColor: '#FFFFFF',
      borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
  },
  cells: {
    style: {
      justifyContent: 'left',
    },
  },
  pagination: {
    style: {
      border: 'none',
      svg: {
        fill: 'rgba(0,0,0,0.54)',
      },
    },
  },
};

const columns: TableColumn<IQleNewHireEnrollmentEvent>[] = [
  {
    name: 'Start Date',
    selector: (row: IQleNewHireEnrollmentEvent) => formatDateConverter(row.planInitialPeriod) || '',
  },
  {
    name: 'End Date',
    selector: (row: IQleNewHireEnrollmentEvent) => formatDateConverter(row.planEndPeriod) || '',
  },
  {
    name: 'Created At',
    selector: (row: IQleNewHireEnrollmentEvent) => formatDateConverter(row.createdAt) || '',
  },
  {
    name: 'Created By',
    selector: (row: IQleNewHireEnrollmentEvent) => row.createdBy?.email || '',
  },
  {
    name: 'Updated At',
    selector: (row: IQleNewHireEnrollmentEvent) => {
      if (row.updatedAt) {
        return formatDateConverter(row.updatedAt) as string;
      }
      return '';
    },
  },
  {
    name: 'Updated By',
    selector: (row: IQleNewHireEnrollmentEvent) => row.updatedBy?.email || '',
  },
];

const QleNewHireEnrollmentTable: React.FC<{ data: IQleNewHireEnrollmentEvent[]; isFetching: boolean }> = ({
  data,
  isFetching,
}) => (
  <DefaultTable
    customStyles={customStyles}
    columns={columns}
    data={data}
    progressPending={isFetching}
    responsive
    pagination={false}
  />
);

export default QleNewHireEnrollmentTable;
